import PropTypes from 'prop-types';
import { useMemo } from 'react';
import SegmentOptions from './SegmentOptions';
import SegmentRating from './SegmentRating';
import SegmentCarrier from './SegmentCarrier';
import SegmentCriticalInfo from './SegmentCriticalInfo';
import SegmentDevider from './SegmentDevider';
import PointsContainer from './Points/PointsContainer';
import FetchingModal from '../popups/FetchingModal';
import * as Styled from './Style';
/**
 * Компонент отображения сегмента поездки. Сегмент содержит в себе информацию по маршруту, по опциям,
 * условия возврата, рейтинг, транспортное средство и т.д.
 */
export const SegmentLayout = ({
  rating,
  options = [],
  busModel,
  carrierName,
  points,
  refundPolicy,
  refundPolicyUrl,
  actions,
  isRefundPolicyOpen,
  criticalInfo = [],
  isCriticalInfoShown,
  isRatingHidden,
  isRatingEnabled,
  isEticket,
  isDashed,
  hasManySegments,
  isOptionsHidden,
  isCarrierHidden,
  isShowSegmentDevider,
  transferTime,
  isIconShow,
  isPreviewDetails,
  carrierAddressLeg,
  carrierEgrulEgis,
  carrierOgrn,
  carrierLegalName
}) => {
  const isOptionsShown = !!(options && options.length) && !isOptionsHidden;
  const isCarrierDetailsShown = (carrierName || busModel) && !isCarrierHidden;
  const isRatingShown = isRatingEnabled && rating && !isRatingHidden;
  const isPolicyShown = refundPolicy || refundPolicyUrl;
  const isTripInfoShown = isCarrierDetailsShown || isRatingShown || isPolicyShown;
  const optionsWithoutPrintedTicket = options.filter(option => option !== 'require-printed-ticket');
  const renderedOptions = isEticket ? optionsWithoutPrintedTicket : options;
  const policyTextContent = useMemo(() => /*#__PURE__*/React.createElement(Styled.RefundWrapper, null, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: refundPolicy
    }
  })), [refundPolicy]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Details, null, /*#__PURE__*/React.createElement(Styled.DetailsContent, {
    isOptionsShown: !isOptionsShown,
    hasManySegments: hasManySegments
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PointsContainer, {
    points: points,
    hasManySegments: hasManySegments,
    isPreviewDetails: isPreviewDetails,
    isExpandable: true
  })), isOptionsShown && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SegmentOptions, {
    options: renderedOptions,
    isIconShow: isIconShow
  })), isTripInfoShown && /*#__PURE__*/React.createElement("div", null, isCarrierDetailsShown && /*#__PURE__*/React.createElement(SegmentCarrier, {
    carrierAddressLeg: carrierAddressLeg,
    carrierEgrulEgis: carrierEgrulEgis,
    carrierOgrn: carrierOgrn,
    carrierLegalName: carrierLegalName,
    carrierName: carrierName,
    busModel: busModel
  }), isRatingShown && /*#__PURE__*/React.createElement(SegmentRating, {
    rating: rating
  }), isPolicyShown && /*#__PURE__*/React.createElement(Styled.ListUnstyled, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Styled.PolicyLink, {
    onClick: actions.openRefundPolicy
  }, I18n.t('components.Segment.refund_policy')), /*#__PURE__*/React.createElement(FetchingModal, {
    url: refundPolicyUrl,
    title: I18n.t('pages.account.return_causes'),
    textContent: policyTextContent,
    isOpen: isRefundPolicyOpen,
    onClose: actions.closeRefundPolicy
  }))))), isCriticalInfoShown && !!criticalInfo.length && /*#__PURE__*/React.createElement(SegmentCriticalInfo, {
    criticalInfo: criticalInfo
  })), isShowSegmentDevider && /*#__PURE__*/React.createElement(SegmentDevider, {
    transferTime: transferTime,
    isDashed: isDashed
  }));
};
SegmentLayout.defaultProps = {
  isRatingHidden: false,
  hasManySegments: false,
  rating: {},
  isCriticalInfoShown: true
};
SegmentLayout.propTypes = {
  /** Объект рейтинга */rating: PropTypes.object,
  /** Остановки автобуса на рейсе */points: PropTypes.array.isRequired,
  /** Условия на рейсе */options: PropTypes.array,
  /** Модель автобуса */busModel: PropTypes.string,
  /** Название перевозчика */carrierName: PropTypes.string,
  carrierAddressLeg: PropTypes.string,
  carrierEgrulEgis: PropTypes.string,
  carrierOgrn: PropTypes.string,
  carrierLegalName: PropTypes.string,
  /** Условия возврата */refundPolicy: PropTypes.string,
  refundPolicyUrl: PropTypes.string,
  actions: PropTypes.object,
  /** Флаг открыто ли модальное окно с условиями возврата */isRefundPolicyOpen: PropTypes.bool,
  /** Флаг показывающий множество сегментов */hasManySegments: PropTypes.bool,
  /** Критическая информация на рейсе */criticalInfo: PropTypes.array,
  isCriticalInfoShown: PropTypes.bool,
  /** флаг показа рейтинга */isRatingHidden: PropTypes.bool,
  /** флаг активации рейтинга */isRatingEnabled: PropTypes.bool,
  /** время пересадки между сегментами */transferTime: PropTypes.string,
  /** флаг наличия признака электронного билета */isEticket: PropTypes.bool,
  /** флаг наличия признака билета туда-обратно */ /** dashed border flag */isDashed: PropTypes.bool,
  /** флаг показа условий на рейсе */isOptionsHidden: PropTypes.bool,
  /** флаг показа разделителя для сегментов */isShowSegmentDevider: PropTypes.bool,
  /** флаг показа информации о перевозчике */isCarrierHidden: PropTypes.bool,
  /** флаг показа иконок на условиях рейса */isIconShow: PropTypes.bool,
  isPreviewDetails: PropTypes.bool
};